import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    // --- הוספנו את החלק הזה ---
    validateStatus: function (status) {
        // תחשיב את הבקשה כמוצלחת אם הסטטוס הוא 2xx או 304
        return (status >= 200 && status < 300) || status === 304;
    }
});

// --- 1. תיקון קריטי ב-Interceptor ---
// מעכשיו, כל בקשה שתשלח דרך 'api' תוסיף אוטומטית את כותרת האימות הנכונה.
api.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        if (token) {
            // שימוש בשיטה הנכונה שאושרה על ידך
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// --- Auth ---
// בפונקציות האלה אין צורך בשינוי, כי השפה נשלחת כחלק מה-formData
export const register = formData => api.post('/auth/register', formData);
export const login = formData => api.post('/auth/login', formData);
export const getCurrentUser = () => api.get('/auth/me');
export const updateProfile = formData => api.put('/auth/profile', formData);

// --- Posts ---
// 2. עדכון הפונקציות שמושכות רשימות של פוסטים
export const getAllPosts = (lang = 'he') => api.get('/posts', { params: { lang } });
export const getPublishedPosts = (lang = 'he') => api.get('/posts/published', { params: { lang } });
export const getPostsByCategory = (category, lang = 'he') => api.get(`/posts/category/${category}`, { params: { lang } });

// הפונקציות הבאות עובדות על ID ספציפי ואינן דורשות פרמטר שפה
export const getPostById = id => api.get(`/posts/${id}`);
export const createPost = formData => api.post('/posts/create', formData); // 'create' ולא '/posts'
export const updatePost = (id, formData) => api.put(`/posts/${id}`, formData);
export const deletePost = id => api.delete(`/posts/${id}`);
export const uploadImage = formData => {
    return api.post('/posts/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

// --- Comments ---
// פונקציות אלה קשורות ל-postId ספציפי ואינן דורשות שינוי
export const getCommentsByPost = postId => api.get(`/comments/post/${postId}`);
export const getAllComments = () => api.get('/comments');
export const createComment = (postId, formData) => api.post(`/comments/post/${postId}`, formData);
export const approveComment = id => api.put(`/comments/${id}/approve`);
export const deleteComment = id => api.delete(`/comments/${id}`);

// --- Subscribers ---
// הפונקציה subscribe כבר מקבלת את כל המידע (כולל שפה) ב-formData
export const subscribe = formData => api.post('/subscribers', formData);
export const verifyEmail = token => api.get(`/subscribers/verify/${token}`);
export const unsubscribe = email => api.delete(`/subscribers/${email}`);
export const getAllSubscribers = () => api.get('/subscribers');

export default api;